/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { useEffect } from "react";
import { useObserver } from "mobx-react-lite";
import { Divider, Grid, Button } from "@material-ui/core";
import {
  useAppInsightsContext,
  useTrackMetric,
} from "@microsoft/applicationinsights-react-js";
import SuccessTick from "../../assets/success_tick.svg";
import { AppInsightMethods } from "../../AppInsightMethods";
import { useGlobalStore } from "../../state/global-store";
import {
  ConstantVariables,
  AppInsightConstants as Constants,
} from "../../constants/Constants";

interface ISuccessScreenProps {
  onBackToHomeClick: () => void;
  onBookAppointmentClick: () => void;
  patientName: string;
}

export default function SuccessScreen(props: ISuccessScreenProps) {
  const pageName = "SuccessScreen";
  const appInsights = useAppInsightsContext();
  const globalStore = useGlobalStore();

  const trackComponent = useTrackMetric(appInsights, pageName);
  useEffect(() => {
    trackComponent();
  }, []);
  /* Keyboard event for going to back to home screen from appointment created success modal */
  const onBackToHomeKeyDown = (event: any) => {
    try {
      if (event.key === "Enter") {
        props.onBackToHomeClick();
        AppInsightMethods.trackAppInsightsEvent(
          pageName,
          Constants.Information,
          `The Back to Home Page button has been clicked on the Appointment Creation Success screen..`,
          globalStore.loginUserEmail,
          window.location.href,
          ""
        );
      }
    } catch (error) {
      AppInsightMethods.TrackAppInsightsException(
        `Error at onBackToHomeKeyDown, Component: ${pageName}, Error: ${error}`
      );
    }
  };

  /* Keyboard event for going to new appointment screen from appointment created success modal */
  const onBookAppointmentKeyDown = (event: any) => {
    try {
      if (event.key === "Enter") {
        props.onBookAppointmentClick();
        AppInsightMethods.trackAppInsightsEvent(
          pageName,
          Constants.Information,
          `The Book Another Appointment button has been clicked on the Appointment Creation Success screen..`,
          globalStore.loginUserEmail,
          window.location.href,
          ""
        );
      }
    } catch (error) {
      AppInsightMethods.TrackAppInsightsException(
        `Error at onBookAppointmentKeyDown, Component: ${pageName}, Error: ${error}`
      );
    }
  };

  return useObserver(() => {
    return (
      <Grid
        container
        justify="center"
        alignItems="center"
        className={"successScreen"}
      >
        <Grid className={"successScreenFirstSection"}>
          <img src={SuccessTick} alt={"Success Tick"} />
          {props.patientName !== "" ? (
            <p>
              {ConstantVariables.AdhocMeetingSuccessScreen}
              <strong>{props.patientName}</strong>
            </p>
          ) : (
            <p>{ConstantVariables.Appointment_Scheduled_Text}</p>
          )}
          <Divider />
        </Grid>
        <Grid className={"successScreenSecondSection"}>
          <Button
            variant="contained"
            className={"teleVisitBtn teleVisitCancelBtn"}
            onClick={props.onBackToHomeClick}
            onKeyDown={(e) => onBackToHomeKeyDown(e)}
          >
            Back to Home
          </Button>
          <Button
            variant="contained"
            className={"teleVisitBtn teleVisitSuccessBtn"}
            onClick={props.onBookAppointmentClick}
            onKeyDown={(e) => onBookAppointmentKeyDown(e)}
          >
            Book Another Appointment
          </Button>
        </Grid>
      </Grid>
    );
  });
}
